

<template>
<!--  <div class="boxall" style="height:3.4rem">-->
  <div class="boxall" style="height:3rem">
<!--  <div class="boxall" :style="{ height: Hrem + 'rem' }">-->
    <div class="alltitle">图书馆宣传栏</div>
    <div class="bannerPc banner-ccslide" id="school" >
      <div  id="library_title"></div>
      <p id="library_description"></p>
    </div>
    <div class="boxfoot">
          <span id="library_date">
          </span>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>
<style scoped lang="scss">

</style>